// Length of a TOTP code.
export const CODE_LENGTH = 6;

// HTTP status codes from the MFA contract (see the Native SSH - MFA spec).
export const MFA_HTTP_STATUS = {
  SUCCESS: 200,
  INVALID: 401, // wrong code — retry allowed
  FORBIDDEN: 403, // locked / not-registered / user-not-found — no retry
  REQUIRED: 428, // code not provided — prompt for TOTP and retry
  SERVICE_UNAVAILABLE: 503, // downstream (AuthMS) failure
};

// Error codes returned in the response body ({ error, message, status }).
export const MFA_ERROR = {
  REQUIRED: 'MFA_REQUIRED',
  INVALID: 'MFA_INVALID',
  ACCOUNT_LOCKED: 'MFA_ACCOUNT_LOCKED',
  NOT_REGISTERED: 'MFA_NOT_REGISTERED',
  USER_NOT_FOUND: 'MFA_USER_NOT_FOUND',
  SERVICE_UNAVAILABLE: 'MFA_SERVICE_UNAVAILABLE',
};

// Outcome the challenge hook derives from a response, used to drive the modal.
export const MFA_OUTCOME = {
  SUCCESS: 'success', // operation succeeded (200)
  REQUIRED: 'required', // 428 — prompt for a TOTP code
  INVALID: 'invalid', // 401 — wrong code, allow another attempt
  TERMINAL: 'terminal', // 403 / 503 — stop, no retry
  PASSTHROUGH: 'passthrough', // any other status — let the caller handle it
};
